import { Buttons } from '../../controls/buttons';
import { ChangeDetectionStrategy, Component, computed, inject, model, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalDialogComponent } from 'src/app/controls/components/advanced/modal-dialog/modal-dialog.component';
import { ControlLabelComponent } from 'src/app/controls/components/internal/control-label/control-label.component';

@Component({
  templateUrl: './test-tool-accept-differences-modal.component.html',
  styleUrl: './test-tool-accept-differences-modal.component.scss',
  imports: [Buttons, ControlLabelComponent, FormsModule, ModalDialogComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TestToolAcceptDifferencesModalComponent {
  private modal = inject(NgbActiveModal);

  isAccept = signal(true);
  title = computed(() => this.isAccept() ? 'Accept Differences' : 'Reject Differences');
  labelText = computed(() => this.isAccept() ? 'Please enter a comment' : 'These differences was accepted with this comment');
  comment = model('');

  ok(): void {
    this.modal.close(this.comment());
  }

  cancel(): void {
    this.modal.dismiss();
  }
}
